import React from "react";
import { connect } from "react-redux";
import { isEqual } from "lodash";
import { DownloadFileAction } from "../../../../actions";
import { Box, Container, DateBox } from "./style";
import Button from "../../../../components/button";
import DatePicker from "../../../../components/datepicker";
import { BoxLoading } from "../../../../components/loading";
import { FILE_TYPES } from "../../../../constants/file";
import { checkPremiumFeature } from "../../../../assets/checkPremium";
import {
  GET_ACCOUNTANT,
  GET_EXCEL,
  GET_PDF,
  PRINT_SUMMARY_PAYMENT_RECEIVE
} from "../../../../constants/premiumActions";
import { RadioButton } from "../../../../components/radioButton";
import moment from "jalali-moment";
import { DATE_FORMAT_IN_NUMBERS } from "../../../../constants/dateTime";

const TODAY = moment().format(DATE_FORMAT_IN_NUMBERS);
class Index extends React.Component {
  state = {
    selected: "",
    dateStatus: false,
    date: TODAY,
    dataChange: false,
    date_error: "",
    selectedRadioButton: -1
  };

  componentDidUpdate(prevProps) {
    if (!this.props.data.modalStatus && this.state.dateStatus) {
      this.setState({
        selected: "",
        dateStatus: false,
        date: TODAY
      });
    }
    if (!isEqual(prevProps.data.modalData, this.props.data.modalData)) {
      this.setState({ dataChange: true });
    }

    if (this.props.data.modalStatus) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }
  icon(type) {
    switch (type) {
      case FILE_TYPES.PDF:
        return "mapsa-pdf-file-format";
      case FILE_TYPES.EXCEL:
        return "mapsa-xlsx-file-format";
      case FILE_TYPES.ACCOUNTANT:
        return "mapsa-calculator";
      default:
        return "mapsa-account-report";
    }
  }
  checkPremiumMessageTrigger(item) {
    if (!item.subFiles) {
      let res;
      if (item.specialType) {
        if (item.specialType === "payment-receive") {
          res = checkPremiumFeature(PRINT_SUMMARY_PAYMENT_RECEIVE, true);
        }
      } else {
        switch (item.type) {
          case FILE_TYPES.PDF:
            res = checkPremiumFeature(GET_PDF, true);
            break;
          case FILE_TYPES.EXCEL:
            res = checkPremiumFeature(GET_EXCEL, true);
            break;
          case FILE_TYPES.ACCOUNTANT:
            res = checkPremiumFeature(GET_ACCOUNTANT, true);
            break;
        }
      }
      if (res){
        this.props.closeModal();
      }
      return res;
    }
  }

  eventMaker(item) {
    if (!this.checkPremiumMessageTrigger(item)) {
      if (item.subFiles) {
        this.props.openModal(item.subFiles);
        this.setState({ dataChange: false });
      } else if (!item.with_date) {
        this.setState({
          selected: "",
          dateStatus: false,
          date: TODAY
        });
        this.props.askFile({
          ...item,
          filters: { ...item.filters, file_type: item.type }
        });
      } else {
        this.setState({
          selected: item,
          dateStatus: true,
          date: TODAY
        });
      }
    }
  }
  showPremiumIcon(item) {
    if (!item.subFiles) {
      if (item.specialType) {
        if (item.specialType === "payment-receive") {
          return checkPremiumFeature(PRINT_SUMMARY_PAYMENT_RECEIVE);
        }
      } else {
        switch (item.type) {
          case FILE_TYPES.PDF:
            return checkPremiumFeature(GET_PDF);
          case FILE_TYPES.EXCEL:
            return checkPremiumFeature(GET_EXCEL);
          case FILE_TYPES.ACCOUNTANT:
            return checkPremiumFeature(GET_ACCOUNTANT);
        }
      }
    }
  }
  render() {
    const { data } = this.props;
    const { selected, date, dateStatus, date_error, dataChange } = this.state;
    if (!data.modalStatus) {
      return "";
    } else {
      return (
        <Container onClick={this.props.closeModal}>
          <Box
            onClick={e => {
              e.stopPropagation();
            }}
            redisplay={dataChange}
          >
            {data.askLoading ? (
              <BoxLoading />
            ) : (
              <div className="download-box">
                <div className="download-modal-title">دریافت خروجی</div>
                {this.state.dataChange && (
                  <ul>
                    {data.modalData.map((item, key) => {
                      const selectedRadioButton =
                        item.with_date && isEqual(item, selected);
                      return (
                        <React.Fragment key={key}>
                          <li
                            className={`${
                              isEqual(selected, item) ? "selected" : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation()
                              this.eventMaker(item);
                            }}
                          >
                            {item.with_date ? (
                              <RadioButton select={selectedRadioButton} />
                            ) : (
                              <i className={`icon ${this.icon(item.type)}`} />
                            )}
                            {item.title}
                            {this.showPremiumIcon(item) && (
                              <i className="premium-icon icon mapsa-premium-plan" />
                            )}
                          </li>
                          {selectedRadioButton && (
                            <DateBox status={true}>
                              <div className="top-box">
                                <div className="first-row">
                                  <span>تاریخ صدور سند:</span>
                                  <DatePicker
                                    input={{
                                      value: date,
                                      onChange: value => {
                                        this.setState({
                                          date: value,
                                          date_error: ""
                                        });
                                      }
                                    }}
                                    meta={{ error: date_error }}
                                  />
                                </div>
                                <div className="text">
                                  تاریخ انتخابی شما به عنوان تاریخ صدور سند
                                  حسابداری در سند ایجاد شده لحاظ خواهد شد.
                                </div>
                              </div>
                            </DateBox>
                          )}
                        </React.Fragment>
                      );
                    })}
                    {!data.askLoading && dateStatus && (
                      <Button
                        btn="ghost"
                        onClick={() => {
                          if (!date) {
                            this.setState({
                              date_error: "تاریخ سند نمی‌تواند خالی باشد!"
                            });
                          } else {
                            this.props.askFile({
                              ...selected,
                              filters: {
                                ...selected.filters,
                                date,
                                file_type: selected.type
                              }
                            });
                          }
                        }}
                      >
                        دریافت سند
                      </Button>
                    )}
                  </ul>
                )}
              </div>
            )}
          </Box>
        </Container>
      );
    }
  }
}

const mapStateToProps = store => {
  return {
    data: store.DownloadFile
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(DownloadFileAction.closeModal());
    },
    askFile: data => {
      dispatch(DownloadFileAction.reportRequest(data));
    },
    openModal: data => {
      dispatch(DownloadFileAction.modalData(data));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
